import { Button, Table } from 'antd';
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import UserGroupApi from '../../functions/api/user/UserGroupApi';
import MyUtil from '../../functions/MyUtil';

class ListUserGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listUserGroups: [],
      widthWindow: window.innerWidth,
    };
  }

  async componentDidMount() {
    const listUserGroups = await UserGroupApi.getAllUserGroup();
    this.setState({ listUserGroups });
  }

  handleInsertButtonClick = () => {
    this.props.history.push(`${this.props.match_parent.url}/add`);
  };

  handleChangeList = (list) => {
    this.setState({ listUserGroups: list });
  };

  render() {
    const { listUserGroups } = this.state;
    const canAdd = MyUtil.hasPermission(this.props.match_parent.url, 'add');
    const canEdit = MyUtil.hasPermission('/group', 'update');

    const columnUserGroups = [
      {
        title: 'User Group Id',
        dataIndex: 'user_group_id',
        key: 'user_group_id',
        fixed: 'left',
      },
      {
        title: 'User Group Name',
        dataIndex: 'user_group_name',
        key: 'user_group_name',
        fixed: 'left',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Chỉnh sửa',
        render: (cell, row) =>
          canEdit && (
            <Link to={`/group/edit/${row.user_group_id}`}>
              <i className="fas fa-edit"></i>
            </Link>
          ),
        fixed: 'right',
      },
    ];

    return (
      <div className="content">
        {canAdd && (
          <Button
            onClick={this.handleInsertButtonClick}
            type="primary"
            size="large"
          >
            Thêm
          </Button>
        )}
        <Table
          rowKey="user_group_id"
          size="small"
          columns={columnUserGroups}
          dataSource={listUserGroups}
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  }
}

export default withRouter(ListUserGroup);
